export default __webpack_public_path__ + "static/media/rc.779dd57d.jpeg";